import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const createJobSuccessMessage = () => {
  notification.success({
    message: 'Job Created Successfully!',
  });
};

const createJobErrorMessage = (err) => {
  notification.error({
    message: err,
  });
};

const {
  createJobBegin,
  createJobSuccess,
  createJobErr,
  jobsReadBegin,
  jobsReadSuccess,
  jobsReadLength,
  jobsReadErr,
  jobsStatsBegin,
  jobsStatsSuccess,
  jobsStatsErr,
  getJobBegin,
  getJobSuccess,
  getJobErr,
  getFiltersBegin,
  getFiltersErr,
  getFiltersSuccess,
  cancelJobBegin,
  cancelJobErr,
  cancelJobSuccess,
  deleteJobBegin,
  deleteJobErr,
  deleteJobSuccess,
  updateJobFilterAction,
} = actions;

const createJob = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(createJobBegin());
      const response = await DataService.post('/job/create', data);
      if (response.status === 200) {
        await dispatch(createJobSuccess(response.data.data));
        createJobSuccessMessage();
        callback();
      } else {
        throw response;
      }
    } catch (err) {
      await dispatch(createJobErr('Something went wrong, Unable to create job.'));
      createJobErrorMessage('Something went wrong, Unable to create job.');
    }
  };
};

const updateJob = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(createJobBegin());
      const response = await DataService.post('/job/update', data);
      if (response.status === 200) {
        await dispatch(createJobSuccess(response.data.data));
        notification.success({
          message: 'Job Updated Successfully!',
        });
        callback(
          ['', 'query', 'quoted', 'orderConfirmed', 'jobCompleted', '', 'invoiceSent'][response.data.data.status],
        );
      } else {
        throw response;
      }
    } catch (err) {
      await dispatch(createJobErr('Something went wrong, Unable to create job.'));
      createJobErrorMessage('Something went wrong, Unable to create job.');
    }
  };
};

const getJobStats = () => {
  return async (dispatch) => {
    try {
      await dispatch(jobsStatsBegin());
      const query = await DataService.gql(QUERY.getStats);
      await dispatch(jobsStatsSuccess(query.data.data));
    } catch (err) {
      await dispatch(jobsStatsErr('Something went wrong, Unable to get stats.'));
    }
  };
};

const getJobById = (id = '', callback = () => false) => {
  return async (dispatch) => {
    try {
      await dispatch(getJobBegin());
      const query = await DataService.gql(QUERY.getJob(id));
      await dispatch(getJobSuccess(query.data?.data?.jobById ?? {}));
      callback();
    } catch (err) {
      await dispatch(getJobErr('Something went wrong, Unable to get job.'));
    }
  };
};

const getFilterData = () => {
  return async (dispatch) => {
    try {
      await dispatch(getFiltersBegin());
      const query = await DataService.gql(QUERY.getFilterData);
      const filterData = { shipName: [], description: [], targetPort: [], boxVesselClass: [] };
      query.data.data.allJobs?.nodes?.forEach((job) => {
        if (job.shipName) {
          filterData.shipName.push({ value: job.shipName, label: job.shipName });
        }
        if (job.description) {
          filterData.description.push({ value: job.description, label: job.description });
        }
        if (job.targetPort) {
          filterData.targetPort.push({ value: job.targetPort, label: job.targetPort });
        }
        if (job.boxVesselClass) {
          filterData.boxVesselClass.push({ value: job.boxVesselClass, label: job.boxVesselClass });
        }
      });
      filterData.shipName = filterData.shipName.filter(
        (obj, index, self) => index === self.findIndex((o) => o.value === obj.value),
      );
      filterData.description = filterData.description.filter(
        (obj, index, self) => index === self.findIndex((o) => o.value === obj.value),
      );
      filterData.targetPort = filterData.targetPort.filter(
        (obj, index, self) => index === self.findIndex((o) => o.value === obj.value),
      );
      filterData.boxVesselClass = filterData.boxVesselClass.filter(
        (obj, index, self) => index === self.findIndex((o) => o.value === obj.value),
      );

      await dispatch(getFiltersSuccess(filterData));
    } catch (err) {
      await dispatch(getFiltersErr('Something went wrong, Unable to job filters.'));
    }
  };
};

const jobsReadData = (
  status = 1,
  search = '',
  isWarning = false,
  filter = {},
  singporeJobs = false,
  country = '',
  first,
  offset,
) => {
  return async (dispatch) => {
    try {
      await dispatch(jobsReadBegin());
      const query = await DataService.gql(
        QUERY.allJobs(status, search, isWarning, filter, singporeJobs, country, first, offset),
      );
      await dispatch(jobsReadSuccess(query.data.data.allJobs.nodes));
      await dispatch(jobsReadLength(query.data.data.allJobs.totalCount));
    } catch (err) {
      dispatch(jobsReadErr(err));
    }
  };
};
const cancelJob = (id = '', callback = () => false) => {
  return async (dispatch) => {
    try {
      await dispatch(cancelJobBegin());
      const query = await DataService.gql(QUERY.cancelJob(id));
      await dispatch(cancelJobSuccess(query.data.data));
      callback();
    } catch (err) {
      dispatch(cancelJobErr(err));
    }
  };
};
const deleteJob = (id = '', callback = () => false) => {
  return async (dispatch) => {
    try {
      await dispatch(deleteJobBegin());
      const query = await DataService.gql(QUERY.deleteJob(id));
      await dispatch(deleteJobSuccess(query.data.data));
      callback();
    } catch (err) {
      dispatch(deleteJobErr(err));
    }
  };
};

const jobsUpdateData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(jobsReadBegin());
      dispatch(jobsReadSuccess(data));
    } catch (err) {
      dispatch(jobsReadErr(err));
    }
  };
};

const updateJobFilter = (data) => {
  return async (dispatch) => {
    dispatch(updateJobFilterAction(data));
  };
};

export {
  jobsReadData,
  jobsUpdateData,
  createJob,
  getJobStats,
  getJobById,
  updateJob,
  getFilterData,
  cancelJob,
  deleteJob,
  updateJobFilter,
};
